import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class RequestConfirmationController extends Controller {
  @service session;

  get loggedIn() {
    return this.session.isAuthenticated;
  }
}
